import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [Toast, NgClass, RouterLink],
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  /**
   * Get the icon class based on toast severity
   */
  getIconClass(severity: string): string {
    const icons: Record<string, string> = {
      success: 'pi pi-check',
      info: 'pi pi-info-circle',
      warn: 'pi pi-exclamation-triangle',
      error: 'pi pi-times-circle',
    };
    return icons[severity] ?? 'pi pi-info-circle';
  }

  /**
   * Get background and border classes based on severity
   */
  getContainerClasses(severity: string): string {
    const classes: Record<string, string> = {
      success: 'border-green-200 bg-green-50/95',
      info: 'border-blue-200 bg-blue-50/95',
      warn: 'border-amber-200 bg-amber-50/95',
      error: 'border-red-200 bg-red-50/95',
    };
    return classes[severity] ?? 'border-slate-200 bg-slate-50/95';
  }

  /**
   * Get text and icon color classes based on severity
   */
  getColorClasses(severity: string): string {
    const classes: Record<string, string> = {
      success: 'text-green-600',
      info: 'text-blue-600',
      warn: 'text-amber-600',
      error: 'text-red-600',
    };
    return classes[severity] ?? 'text-slate-600';
  }
}
